import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuenSagashikata: BlogMetaData = {
  title: '保育園の探し方｜候補園の見つけ方から見学予約まで保活の手順を解説',
  description:
    '保育園の探し方がわからない方へ。自治体窓口・Googleマップ・口コミなど情報収集の方法から、認可・認可外別の調べ方、候補リストの作り方、見学予約の流れまで、保活の手順をステップごとに解説します。',
  thumbnailUrl: '/img/blog-hoikuen-sagashikata.webp',
  filePath: buildBlogFilePath('hoikuen-sagashikata'),
  category: BLOG_CATEGORY.NURSERY,
};
